import { gql } from "@/services/httpAdapter.ts";

export const onFinanceDealsUpdated = gql`
	subscription onFinanceDealsUpdated($commissionCycleId: String!, $payPeriodId: String!) {
		onFinanceDealsUpdated(commissionCycleId: $commissionCycleId, payPeriodId: $payPeriodId) {
			locationId
			commissionCycleId
			payPeriodId
			financeDeals {
				_id
				locationId
				commissionCycleId
				payPeriodId
				# Data Related
				age
				date
				stockNumber
				customerNumber
				customerName
				dealNumber
				vinNumber
				lender
				amountFinanced
				financeEmployeeId
				financeEmployeeName
				salesOneEmployeeId
				salesOneEmployeeName
				salesTwoEmployeeId
				salesTwoEmployeeName
				tradeACV
				tradeNet
				closeDate
				activeStatusDV
				dealOriginalDate
				dealStartDate
				dealStatus
				dealType
				financeReserve
				offsetStatusDate
				salesManager
				statusCodeDV
				statusDate
				vstCode
			}
		}
	}
`;
